import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Globe, ChevronDown } from 'lucide-react'
import clsx from 'clsx'

const LanguageSwitch = () => {
  const { i18n } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const languages = [
    { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
    { code: 'en-US', name: 'English', flag: '🇺🇸' },
    { code: 'vi-VN', name: 'Tiếng Việt', flag: '🇻🇳' },
    { code: 'id-ID', name: 'Bahasa Indonesia', flag: '🇮🇩' },
    { code: 'th-TH', name: 'ไทย', flag: '🇹🇭' },
    { code: 'ms-MY', name: 'Bahasa Melayu', flag: '🇲🇾' },
    { code: 'ms-BN', name: 'Bahasa Brunei', flag: '🇧🇳' },
    { code: 'km-KH', name: 'ភាសាខ្មែរ', flag: '🇰🇭' },
    { code: 'lo-LA', name: 'ພາສາແລາວ', flag: '🇱🇦' },
    { code: 'my-MM', name: 'မြန်မာဘာသာ', flag: '🇲🇲' }
  ]

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0]

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        className="flex items-center space-x-1 px-2 py-2 text-base text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors flex-shrink-0"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Globe size={16} className="flex-shrink-0" />
        <span className="hidden lg:block text-sm max-w-16 truncate">{currentLanguage.name}</span>
        <span className="lg:hidden text-sm">{currentLanguage.flag}</span>
        <ChevronDown size={16} className={clsx('transition-transform flex-shrink-0', isOpen && 'rotate-180')} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg border border-gray-200 z-20">
            <div className="py-1">
              {languages.map((language) => (
                <button
                  key={language.code}
                  className={clsx(
                    'flex items-center space-x-2 w-full px-3 py-2 text-sm text-left hover:bg-gray-100 transition-colors',
                    language.code === i18n.language && 'bg-primary-50 text-primary-700'
                  )}
                  onClick={() => handleLanguageChange(language.code)}
                >
                  <span className="text-base flex-shrink-0">{language.flag}</span>
                  <span className="truncate text-ms">{language.name}</span>
                  {language.code === i18n.language && (
                    <span className="ml-auto text-primary-600 flex-shrink-0 text-xs">✓</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default LanguageSwitch 